import { FC } from 'react';

import Color from 'src/constants/color';

const STROKE_WIDTH = 1.5;
const DOT_RADIUS = 3;
const TEXT_OFFSET = 10;
const TEXT_HEIGHT = 12;
const BG_STROKE_WIDTH = 5;
const BG_STROKE_COLOR = '#fff';
const BG_STROKE_OPACITY = 0.5;

export enum TitlePosition {
    Top = 'top',
    Bottom = 'bottom',
}

interface DotProps {
    x: number;
    y: number;
    color?: Color;
    title?: string;
    titlePosition?: TitlePosition;
}

const Dot: FC<DotProps> = ({ color = Color.NormalBlue, x, y, title, titlePosition = TitlePosition.Top }) => {
    const yTextOffset = titlePosition === TitlePosition.Bottom ? TEXT_HEIGHT + TEXT_OFFSET : -TEXT_OFFSET;
    const yPosition = y + yTextOffset;
    return (
        <g>
            <circle cx={x} cy={y} r={DOT_RADIUS} stroke={color} strokeWidth={STROKE_WIDTH} fill="white" />
            {title && (
                <>
                    {/* Белая полупрозрачная подложка под текстом */}
                    <text
                        x={x}
                        y={yPosition}
                        stroke={BG_STROKE_COLOR}
                        strokeWidth={BG_STROKE_WIDTH}
                        strokeOpacity={BG_STROKE_OPACITY}
                    >
                        {title}
                    </text>
                    <text x={x} y={yPosition}>
                        {title}
                    </text>
                </>
            )}
        </g>
    );
};

export default Dot;
